var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "prefix__a",
    width: 180,
    height: 180,
    x: 0,
    y: 0,
    rx: 90
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#CAD3C0",
    fillRule: "nonzero",
    xlinkHref: "#prefix__a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#E0EAD5",
    fillRule: "nonzero",
    mask: "url(#prefix__b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(13 54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.677 75.444L114.772 36.33c-.889-.884-2.049-1.33-3.209-1.33h-3.751c-1.16 0-2.32.446-3.209 1.33l-44.76 45.01-17.571-17.667c-.889-.893-2.049-1.34-3.209-1.34h-3.751c-1.16 0-2.32.447-3.209 1.33L1.323 84.556C.444 85.448 0 86.615 0 87.781v34.663C0 124.96 2.03 127 4.531 127H150.47c2.501 0 4.531-2.04 4.531-4.556V78.67c0-1.167-.444-2.333-1.323-3.226z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 21.5,
    r: 21.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultImage);
export default __webpack_public_path__ + "static/media/default-image.2dd21c4ebfd7760f36dd5a9a4ba07672.svg";
export { ForwardRef as ReactComponent };